import React from 'react';
import Button from '../../../Button/Button';
import { ModalHeader } from '../../../Modal/Modal';
import LearnMore from '../LearnMore';
const SpaceAssetsSelectorModalHeader = (props) => {
  const { closeModal, handleStackAssetsSwitch, hideStackAssetsSwitch, mode } = props;
  const isFolderPickerMode = mode === 'moveTarget' || mode === 'uploadTarget';

  const getTitle = () => {
    if (mode === 'moveTarget') return 'Move Assets';
    if (mode === 'uploadTarget') return 'Upload Assets to Asset Management';
    return 'Select Asset(s)';
  };

  return (
    <>
      <ModalHeader
        title={
          <div className="flex-v-center SpaceAssetsModalHeader">
            <div className='SpaceAssetsModalHeader__title'>
              {getTitle()}
            </div>
            {!isFolderPickerMode && (
              <div title={'Learn More'}>
                <LearnMore
                  className={'Help-icon'}
                  testId="am-v2-space-assets-learn-more-icon"
                  link={'https://www.contentstack.com/docs/developers/guide/using-assets-in-contentstack/'}
                  target={'blank'}
                  helpIcon={true}
                  moduleName={'Space Assets'}
                />
              </div>
            )}
            {!hideStackAssetsSwitch && !isFolderPickerMode && (
              <div className="SpaceAssetsModalHeader__switch">
                <Button
                  buttonType="link"
                  version="v2"
                  size="small"
                  testId="cs-stack-assets-modal-switch"
                  onClick={(e: React.MouseEvent<HTMLButtonElement>) => handleStackAssetsSwitch(e)}>
                  Switch to Stack Assets
                </Button>
              </div>
            )}
          </div>
        }
        closeModal={closeModal}
      />
    </>
  );
};

export default SpaceAssetsSelectorModalHeader;
